import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="mall, store, shop, business"><path fillRule="evenodd" clipRule="evenodd" d="M2 7.75C2 5.67893 3.67893 4 5.75 4H18.25C20.3211 4 22 5.67893 22 7.75V16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V7.75ZM16 18.5V12.75C16 11.7835 15.2165 11 14.25 11H12.75V18.5H16ZM11.25 18.5V11H9.75C8.7835 11 8 11.7835 8 12.75V18.5H11.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMall;
